import { Box, Chip, Typography } from "@mui/material";
import styles from "./style.module.css";
import { useTheme } from "../../../../../../../context/themeContext";
import { RoomOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const Card = ({ project }) => {
  const { theme, darkMode } = useTheme();
  const isLive = project.status === "Under Review" ? false : true;
  const completed = project.status === "Completed" ? true : false;
  const navigate = useNavigate();

  return (
    <Box
      className={styles.card}
      sx={{
        bgcolor: darkMode ? "#333" : theme.palette.lightgrey.lightgrey00,
      }}
    >
      <Box
        className={styles.pic}
        onClick={() => navigate(`/projects/${project.id}`)}
        sx={{
          cursor: "pointer",
          backgroundImage: `url(${project.project_cover_image})`,
        }}
      ></Box>
      <Box className={styles.content}>
        <Box className={styles.frame}>
          <Typography
            sx={{
              display: "flex",
              alignSelf: "stretch",
              color: darkMode
                ? theme.palette.darkgrey.darkgreybody50
                : theme.palette.darkgrey.darkgrey600,
              fontSize: "16px",
              fontWeight: "700",
            }}
          >
            {project.title}
          </Typography>
          <Box className={styles.frame2}>
            <Chip
              label={project.category}
              sx={{
                height: "auto",
                padding: "3px 12px",
                bgcolor:
                  (project.category === "Brand" && "#EC7508") ||
                  (project.category === "Cause" && "#05B240") ||
                  (project.category === "Creator" && "#09B999") ||
                  (project.category === "Media" && "#B90988"),
                color: "#FFF",
                textTransform: "capitalize",
                fontSize: "12px",
              }}
            />
            <Chip
              label={isLive ? "Live" : "Pending Review"}
              sx={{
                fontSize: "12px",
                height: "auto",
                padding: "3px 12px",
                bgcolor: isLive
                  ? theme.palette.success.dark
                  : theme.palette.warning.main,
                color: "#FFF",
              }}
            />
            <Chip
              label={completed && "Completed"}
              sx={{
                display: !completed && "none",
                fontSize: "12px",
                height: "auto",
                padding: "3px 12px",
                bgcolor: theme.palette.primary.main,
                color: "#FFF",
              }}
            />
          </Box>
        </Box>
        <Box className={styles.action}>
          <Box className={styles.locations}>
            <RoomOutlined
              sx={{
                width: "16px",
                height: "16px",
                color: darkMode
                  ? theme.palette.darkgrey.darkgrey400
                  : theme.palette.darkgrey.darkgrey500,
              }}
            />
            <Typography
              sx={{
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: "1",
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: darkMode
                  ? theme.palette.darkgrey.darkgrey400
                  : theme.palette.darkgrey.darkgrey500,
                fontSize: "12px",
                fontWeight: "500",
              }}
            >
              {project.location_type === "Remote"
                ? "Remote"
                : project.location_name}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Card;
